import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, IconButton, Typography } from "@mui/material";
import { getBlockStatus } from "../axios/axiosFunctions";
import PendingIcon from '@mui/icons-material/Pending';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Block360Card = ({block,assessmentId,changeTab,setCurrentBlock}) => {
    
    const {userId} = useParams();
    const [blockStatus, setBlockStatus] = useState(false);

    useEffect(() => {
        const getStatus = async()=>{
            const status = await getBlockStatus(block._id,assessmentId,userId,true);
            setBlockStatus(status.completed);
        }
        getStatus();
    }, [block,assessmentId]);

    const handleIconClick = ()=>{
        setCurrentBlock(block);
        changeTab(1);
    }    

    return (
    <Box sx={{backgroundColor:block.color,padding:"35px 40px",display:"flex", justifyContent:"space-between",alignItems:"center",borderRadius:"10px", marginBottom:"20px"}}>
        <Typography variant="h5" fontWeight={"500"} color="white" dangerouslySetInnerHTML={{ __html: block?.name }}/>
        {
            blockStatus === "completed" &&
            <IconButton onClick={handleIconClick}>
                <CheckCircleIcon className="invertIconBlock"/>
            </IconButton>
        }
        {
            blockStatus === "blocked" && <PendingIcon className="invertIconBlock"/>
        }
        {
            blockStatus === "empty" && 
            <IconButton onClick={handleIconClick}>
                <ArrowForwardIcon className="invertIconBlock"/>
            </IconButton>
        }
    </Box>
    )
}

export default Block360Card